import crud from './helpers/crud';

const getTeamRoutingRules = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_TEAM_ROUTING_RULES',
      fail: 'FAILED_GET_TEAM_ROUTING_RULES',
      end: 'FINISH_GET_TEAM_ROUTING_RULES',
    },
    method: 'GET',
    url: '/api/v1/team_routing_rules',
  })
);

const createTeamRoutingRule = (ruleObject) => (
  crud({
    dispatch: {
      begin: 'BEGIN_CREATE_TEAM_ROUTING_RULE',
      fail: 'FAILED_CREATE_TEAM_ROUTING_RULE',
      end: 'FINISH_CREATE_TEAM_ROUTING_RULE',
    },
    method: 'POST',
    data: { team_routing_rule: ruleObject },
    url: '/api/v1/team_routing_rules',
  })
);

const updateTeamRoutingRule = (id, ruleObject) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_TEAM_ROUTING_RULE',
      fail: 'FAILED_UPDATE_TEAM_ROUTING_RULE',
      end: 'FINISH_UPDATE_TEAM_ROUTING_RULE',
    },
    method: 'PUT',
    url: `/api/v1/team_routing_rules/${id}`,
    data: { team_routing_rule: ruleObject },
  })
);

const deleteTeamRoutingRule = (id) => (
  crud({
    dispatch: {
      begin: 'BEGIN_DELETE_TEAM_ROUTING_RULE',
      fail: 'FAILED_DELETE_TEAM_ROUTING_RULE',
      end: 'FINISH_DELETE_TEAM_ROUTING_RULE',
    },
    method: 'DELETE',
    url: `/api/v1/team_routing_rules/${id}`,
  })
);

const reorderTeamRoutingRules = (ruleIds) => (
  crud({
    dispatch: {
      begin: 'BEGIN_REORDER_TEAM_ROUTING_RULES',
      fail: 'FAILED_REORDER_TEAM_ROUTING_RULES',
      end: 'FINISH_REORDER_TEAM_ROUTING_RULES',
    },
    method: 'POST',
    url: '/api/v1/team_routing_rules/reorder',
    data: { rule_ids: ruleIds },
  })
);

const getAllLabelsForTeamRoutingRules = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_TEAM_ROUTING_RULE_LABELS',
      fail: 'FAILED_GET_TEAM_ROUTING_RULE_LABELS',
      end: 'FINISH_GET_TEAM_ROUTING_RULE_LABELS',
    },
    method: 'GET',
    url: '/api/v1/labels?no_pagination=true',
  })
);

// Addressee-condition picker: searches the org contacts list. Results land in
// state.teamRoutingRules.addressees (kept out of the shared addresses slice).
const searchAddresseesForTeamRoutingRules = (search) => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_TEAM_ROUTING_RULE_ADDRESSEES',
      fail: 'FAILED_GET_TEAM_ROUTING_RULE_ADDRESSEES',
      end: 'FINISH_GET_TEAM_ROUTING_RULE_ADDRESSEES',
    },
    method: 'GET',
    url: `/api/v1/recipients?contains=${encodeURIComponent(search)}`,
  })
);

export {
  getTeamRoutingRules,
  createTeamRoutingRule,
  updateTeamRoutingRule,
  deleteTeamRoutingRule,
  reorderTeamRoutingRules,
  getAllLabelsForTeamRoutingRules,
  searchAddresseesForTeamRoutingRules,
};
